<template>
  <div class="panel">
    <transition-group name="list" :duration="{ enter: 500, leave: 0 }">
      <v-alert
        v-for="alert in alerts"
        :key="alert.id"
        @mouseenter="onMouseEnter(alert)"
        v-model="alert.show"
        @update:model-value="onClickClose(alert)"
        class="rounded-lg"
        closable
        elevation="4"
        :type="alert.type"
      >
        {{ alert.message }}
      </v-alert>
    </transition-group>
  </div>
</template>

<script>
import {emitter} from "@/app";

export default {
  name: 'AlertPanel',
  props: {
    displayTimeout: {
      type: Number,
      default: 5000,
    },
  },
  mounted() {
    this.emitter.on('error', (msg) => {
        this.pushAlert('error', msg);
    });
    this.emitter.on('info', (msg) => {
        this.pushAlert('info', msg);
    });
  },
  destroyed() {
    this.timeouts.forEach((timer) => clearTimeout(timer));
    this.timeouts = [];
    this.alerts = [];
  },
  methods: {
    onClickClose(alert) {
      if (!alert.show) {
        this.cleanUpAlert(alert.id);
      }
    },
    pushAlert(type, message) {
      let id = this.id++;
      let timer = setTimeout(() => {
        this.alertTimedOut(id);
      }, this.displayTimeout);
      this.timeouts.push(timer);
      this.alerts.push({
        id: id,
        type: type,
        message: message,
        hideOnTimeout: true,
        show: true,
        timer: timer,
      });
    },
    alertTimedOut(id) {
      let idx = this.alerts.findIndex((e) => e.id === id);
      if (idx >= 0 && this.alerts[idx].hideOnTimeout) {
        this.cleanUpAlert(id);
      }
    },
    cleanUpAlert(id) {
      let idx = this.alerts.findIndex((e) => e.id === id);
      if (idx >= 0) {
        this.cleanUpTimer(this.alerts[idx].timer);
        this.alerts.splice(idx, 1);
      }
    },
    cleanUpTimer(timerId) {
      let idx = this.timeouts.findIndex((id) => id === timerId);
      if (idx >= 0) {
        clearTimeout(this.timeouts[idx]);
        this.timeouts.splice(idx, 1);
      }
    },
    onMouseEnter(alert) {
      alert.hideOnTimeout = false;
    },
  },
  data() {
    return {
      id: 0,
      alerts: [],
      timeouts: [],
      emitter,
    };
  },
};
</script>

<style lang="scss" scoped>
.panel {
  position: fixed;
  top: 110px;
  right: 18px;
  z-index: 2000;
  max-width: 600px;
}
</style>
